import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import React from 'react'
import { useRecordContext, useTranslate } from 'react-admin'

export const ExtraFieldModal = ({open, handleClose, field}) => {
    const record = useRecordContext()
    const info = record[field]
    const translate = useTranslate()
  return (
    <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
                <Typography variant='h6' component='div' textAlign={'center'}>
                {translate(`ra.field.${field}`)}
                </Typography>
            </DialogTitle>
            <DialogContent>
              <div
                dangerouslySetInnerHTML={{__html:info}}
              />
            <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
                <Button onClick={handleClose} variant='outlined' color='error'>
                {translate('ra.action.close')}
                </Button>
            </DialogActions>
            </DialogContent>
        </Dialog>
  )
}
